import React from "react";
import { useTranslation } from "react-i18next";
import { map } from "lodash";
import { ParcelOrderList } from "Components/order-management/parcel-order-list";
import useSession from "Hooks/session.hook";
import { ParcelTypeEnums } from "Data/order";
import { Button } from "@life-line-lab/components-react";
import { useOrderListingStates } from "Helpers/index";

const OrderTab = ({ baseColumns, handleRefreshData, handleModalAction }) => {
  const { roles } = useSession();
  const { t } = useTranslation();
  const { selectedRows } = useOrderListingStates();
  const customerColumns = baseColumns.concat([
    {
      title: t("label.volume").toLocaleUpperCase(),
      dataIndex: ["dimension"],
      width: 70,
      ellipsis: true,
      render: (dimension: any, record: any) => {
        return record.orderType !== ParcelTypeEnums.SPLIT ? (
          <span>
            {dimension?.length} x {dimension?.width} x {dimension?.height}
          </span>
        ) : (
          <span>{record.totalVolume} cm³</span>
        );
      },
    },
    {
      title: t("label.weight").toLocaleUpperCase(),
      dataIndex: ["weight"],
      width: 70,
      render: (weight: string, record: any) => {
        return record.orderType !== ParcelTypeEnums.SPLIT ? (
          <span>{weight || <span>&#11835;</span>}</span>
        ) : (
          <span>{record.totalWeight || <span>&#11835;</span>}</span>
        );
      },
    },
    {
      title: t("label.type").toLocaleUpperCase(),
      dataIndex: ["parcels"],
      width: 80,
      ellipsis: true,
      render: (parcels: any[], record: any) => {
        return record.orderType !== ParcelTypeEnums.SPLIT ? (
          <span>
            {map(parcels, (parcel) => {
              return (
                <span>
                  {parcel?.name || <span>&#11835;</span>}
                  <br />
                </span>
              );
            })}
          </span>
        ) : (
          <span>{t("label.mixedParcels")}</span>
        );
      },
    },
    {
      title: t("label.value").toLocaleUpperCase(),
      dataIndex: ["totalValueOfGoods"],
      width: 70,
      render: (totalValueOfGoods: any) => {
        return (
          <span>
            {parseInt(totalValueOfGoods).toLocaleString() || (
              <span>&#11835;</span>
            )}
            <br />
          </span>
        );
      },
    },
  ]);

  const companyColumns = customerColumns.concat({
    title: t("label.action").toLocaleUpperCase(),
    dataIndex: [],
    width: 200,
    render: (_: any, record: any) => (
      <div className="btn-actions-container">
        <Button
          type="success"
          label={t("action.confirm")}
          onClick={() => {
            const allOrderIDs = record.childrenOrderIDs
              ? [record._id, ...record.childrenOrderIDs]
              : [record._id];
            handleModalAction("CONFIRM", allOrderIDs);
          }}
          className="approve-btn"
        />
        <Button
          type="primary"
          label={t("action.flag")}
          onClick={() => {
            const allOrderIDs = record.childrenOrderIDs
              ? [record._id, ...record.childrenOrderIDs]
              : [record._id];
            handleModalAction("FLAG", allOrderIDs, record._id, record.senderID);
          }}
          className="flag-btn"
        />
      </div>
    ),
  });

  return (
    <ParcelOrderList
      columns={
        roles[0].type == "CUSTOMER"
          ? customerColumns
          : roles[0].type == "COMPANY"
          ? companyColumns
          : baseColumns
      }
      additionalComponent={
        <>
          {roles[0].type == "COMPANY" && (
            <Button
              label={t("action.massConfirm")}
              type="primary"
              isDisabled={selectedRows.length == 0}
              size="large"
              onClick={() => handleModalAction("MASSCONFIRM")}
            />
          )}
        </>
      }
      isCheckBoxShown={true}
      filterItems={
        roles[0].type !== "CUSTOMER"
          ? ["deliveryType", "customersList"]
          : ["deliveryType"]
      }
      radioButtonComponent={undefined}
      handleRefreshData={handleRefreshData}
    />
  );
};

export default OrderTab;
